// Thin wrappers around /api/fleet — the model-routing registry and the heavy
// lane's live swarm (backend/modules/fleet). Any authenticated user server-
// side; the PAGE is mindshine-staff-gated (see utils/staff.js).
import { fetchData } from '../fetchapi/fetchapi';

export async function getFleetModels() {
  return fetchData('fleet/models');
}

// Heavy-lane swarm: running / queued / waiting app requests with the parsed
// worker tick, pod liveness, typical durations and recent results.
export async function getFleetHeavy() {
  return fetchData('fleet/heavy');
}

export async function setModelRoute(consumer, modelId) {
  return fetchData(`fleet/routes/${encodeURIComponent(consumer)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ model_id: modelId }),
  });
}
